import { render, staticRenderFns } from "./pdfTable.vue?vue&type=template&id=87139bec&scoped=true"
import script from "./pdfTable.vue?vue&type=script&lang=js"
export * from "./pdfTable.vue?vue&type=script&lang=js"
import style0 from "./pdfTable.vue?vue&type=style&index=0&id=87139bec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87139bec",
  null
  
)

export default component.exports